import { Suspense } from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import { Shell } from './components/Shell';
import { t } from './i18n';
import { ROUTES } from './routes';

/** Solange das Bündel einer Seite lädt: ruhige Fläche im Inhalt, Navigation bleibt stehen. */
function PageLoading() {
  return (
    <div className="page-loading" role="status" aria-live="polite">
      <span className="sr-only">{t('shell.pageLoading')}</span>
      <div className="page-loading-bar" aria-hidden />
      <div className="page-loading-card" aria-hidden />
    </div>
  );
}

/** Unbekannte Adresse: eigener Text statt Platzhalter, mit Weg zurück. */
function NotFound() {
  return (
    <>
      <header>
        <div className="page-kicker">404</div>
        <h1 className="page-title">{t('shell.notFound')}</h1>
      </header>
      <div className="card">
        <p className="muted">{t('shell.notFoundText')}</p>
        <Link className="btn btn-primary" to="/" style={{ textDecoration: 'none' }}>{t('shell.notFoundBack')}</Link>
      </div>
    </>
  );
}

export function App() {
  return (
    <Shell>
      <Suspense fallback={<PageLoading />}>
        <Routes>
          {ROUTES.map((r) => (
            <Route key={r.path} path={r.path} element={r.element} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Shell>
  );
}
